import React, { useEffect, useState } from 'react';
import HeaderFFF from '../../../components/HeaderFFF'
import Header from '../../../components/Header'
import Footer from "../../../components/Footer";
import { Link } from 'react-router-dom';
import '../../../styles/injury.css'

export default function ChronicPain() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
    
        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth <= 991);
            };
    
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);
    
        return(
            <>
            {isMobile ? <Header /> : <HeaderFFF />}
        <div id="injury">
            <div id="fields-header-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <h2>Chronic Pain</h2>
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
            <div className="pi-go-back">
                        <Link to="/fields-of-expertise/personal-injury">Take me back</Link>
            </div>
            <div className="pi-text">
                <p>Contrary to popular belief, chronic pain is a real phenomenon that plagues thousands of people
every day, and chronic pain lawyers in Toronto are willing to hear your case and represent you
in your time of need. Chronic pain does not always yield physical or medical evidence, so it can
be difficult for physicians to explain what is causing the pain. Other times, chronic pain and soft
tissue injuries are caused by physical injury. <b>Chronic pain personal injury lawyers</b> should be
notified immediately to help clients get the compensation they deserve from the insurance
companies.<br/><br/>
<span className="pi-sub-section">Types of Chronic Pain/Soft Tissue Personal Injury Cases and Claims We Can Handle</span>
At CLV, we handle the following types of <b>chronic pain and soft tissue injuries:</b>
<ul>
<li> <b>Migraine Headaches:</b> targets one side of the head, accompanied by blurred vision or
nausea</li>
<li> <b>Reflex Sympathetic Dystrophy (RSD):</b> also known as Type 1 Complex Regional Pain
Syndrome, cause unknown; symptoms include: pain, swelling, vasomotor dysfunction of
extremities, usually caused by trauma or surgery</li>
<li><b> Whiplash Injuries to the Back or Neck:</b> head is suddenly whipped back, forth or both
causing strain on the back or neck</li>
<li> <b>Fibromyalgia:</b> chronic musculoskeletal pain, joint and muscle tenderness, exhaustion</li>
<li> <b>Soft Tissue Injuries:</b> joint or ligament pain caused by physical injury or overuse of parts
of the body</li>
<li><b>Chronic Lower Back Pain:</b> recurrent pain in the lower back caused by injury</li>

<li> <b>Temporomandibular Disorders:</b> damage to temporal bones that connect jaw to skull</li>
<li> <b>Neuropathic Pain:</b> chronic pain where damaged nerves send incorrect signals to pain
centers, causing pain multiple parts of body</li>
<li> <b>Disc Injuries Causing Chronic Pain:</b> slipped or prolapsed disc causes chronic pain in
spinal nerves</li>
<li> <b>Knee Injuries Causing Chronic Pain:</b> tendinitis, chondromalacia patella, gout, bursitis</li>
</ul>
</p>
            </div>
        </div>
            <Footer />
        </>
        );
}